import React, { useState, useCallback } from 'react';
import { PulseFeed } from '../feed/PulseFeed';
import { usePracticePulse } from '../../hooks/usePracticePulse';
import './PersistentDrawer.css';

/**
 * Persistent Drawer Component
 * Collapsible sidebar for clinical views — shows PulseFeed.
 * Main content expands to full width when closed.
 */
export const PersistentDrawer = ({
  children,
  defaultOpen = false,
  drawerWidth = 320,
  language = 'he',
  onNavigate
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const { hasAIAlerts, aiAlertCount } = usePracticePulse({ autoRefresh: true });
  const isHebrew = language === 'he';

  const toggleDrawer = useCallback(() => {
    setIsOpen(prev => !prev);
  }, []);

  return (
    <div className={`persistent-drawer-layout ${isOpen ? 'drawer-open' : 'drawer-closed'}`}>
      {/* Main Content Area — Expands when drawer closed */}
      <main className="drawer-main-content">
        {children}
      </main>

      {/* Drawer */}
      <aside
        className="persistent-drawer"
        style={{ width: isOpen ? drawerWidth : 0 }}
      >
        {/* Collapse Trigger */}
        <button
          className="drawer-collapse-trigger"
          onClick={toggleDrawer}
          aria-expanded={isOpen}
          aria-label={isOpen
            ? (isHebrew ? '\u05E1\u05D2\u05D5\u05E8 \u05E4\u05D9\u05D3' : 'Close feed')
            : (isHebrew ? '\u05E4\u05EA\u05D7 \u05E4\u05D9\u05D3' : 'Open feed')
          }
        >
          <span className="trigger-icon">
            {isOpen ? '\u25B6' : '\u25C0'}
          </span>
          {!isOpen && (
            <>
              <span className="trigger-label">
                {isHebrew ? '\u05E4\u05D9\u05D3' : 'Feed'}
              </span>
              {hasAIAlerts && (
                <span className="trigger-badge">{aiAlertCount}</span>
              )}
            </>
          )}
        </button>

        {/* Drawer Content */}
        <div className="drawer-content">
          <PulseFeed
            mode="compact"
            showFilters={false}
            showHeader={true}
            language={language}
            onNavigate={onNavigate}
          />
        </div>
      </aside>
    </div>
  );
};
